import React, {useEffect, useState} from 'react';
import { withStyles } from "@mui/styles";
import { Styles } from "../../../../config/design/styles";
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography} from '@mui/material';
import {connect} from "trim-redux";
import {useTranslation} from "react-i18next";
import {X, Trash} from "lucide-react";
import Button from "@mui/material/Button";
import {useLocation, useNavigate} from "react-router-dom";
import axios from "axios";
import {defaultVariables} from "../../../../config";
import {updateRedux} from "../../../../config/Security"; // Import useMediaQuery and Theme

function MultiVendorDialog({isAuth,open,user, setOpen }) {
    const { t } = useTranslation();
    const navigation = useNavigate();
    const location = useLocation();
    const handleBackToVendor = () => {
        navigation(`/vendor/${user.cart_shop?.slug}`);
        setOpen(false)
    }
    const handleClearCart = async () => {
        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`,
            },
        };
        try {
            setOpen(false)
            await axios.get(`${defaultVariables.url}/cart/clear`, config);
            await updateRedux();

        } catch (error) {
            console.error('Error updating server:', error.response || error);
        }


    };

    return (
        <>
            {
                !!isAuth &&
                <>
                    <Dialog  open={open} onClose={() => setOpen(false)}>
                        <DialogTitle>
                            {t('multiVendor')}
                            <IconButton
                                onClick={() => setOpen(false)}
                                style={{position:"absolute",right:15,top:15}}
                                size="small"
                            >
                                <X className="lucide-icon"/>
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <Typography>{t('multiVendorDesc')}</Typography>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color="text"
                                startIcon={<Trash/>}
                                onClick={() => handleClearCart()}
                            >
                                {t('cleanMyCart')}
                            </Button>
                            <Button
                                variant="contained"
                                comp
                                onClick={() => handleBackToVendor()}
                            >
                                {t('backTo')} {user.cart_shop?.name}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            }

        </>

    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
    user: state.user,
});

export default withStyles(Styles)(connect(mapStateToProps)(MultiVendorDialog));
